/**
 * @namespace PIXI.AccessibilityManager
 */
export { default as accessibleTarget } from './accessibleTarget';
export { default as AccessibilityManager } from './AccessibilityManager';
